import { accountsLink } from '@accounts/apollo-link';
import { AccountsClient } from '@accounts/client';
import { AccountsClientPassword } from '@accounts/client-password';
import GraphQLClient from '@accounts/graphql-client';
import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { posthog } from '@/analytics/posthog';

import { tokenStorage } from './tokenStorage';

let tenant_domain;

if (typeof window !== 'undefined') {
  tenant_domain = window.location.hostname;
}

const customFetch = (uri: string, options: any) => {
  const { operationName } = JSON.parse(options.body);

  // Get PostHog session ID to link frontend and backend events
  let sessionId: string | undefined;
  try {
    sessionId =
      typeof window !== 'undefined' ? posthog.get_session_id() : undefined;
  } catch {
    // Analytics context must never prevent an authentication request.
    sessionId = undefined;
  }

  // Add session ID to headers
  const headers = {
    ...options.headers,
    'x-posthog-session-id': sessionId || '',
  };

  return window.fetch(`/graphql2?opname=${operationName}`, {
    ...options,
    headers,
  });
};

const link = createHttpLink({
  fetch: customFetch,
  headers: {
    tenant_domain,
  },
});

const graphqlClient = new GraphQLClient({
  graphQLClient: new ApolloClient({
    link,
    cache: new InMemoryCache(),
  }),
});

export const accountsClient = new AccountsClient(
  { tokenStorage },
  graphqlClient
);

export const accountsClientPassword = new AccountsClientPassword(
  accountsClient
);

export const authLink = accountsLink(() => accountsClient);
